import React, { useEffect, useMemo } from 'react';
import { Center, Heading, Image, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { useReduxDispatch } from '../../../app/store';
import chargerImg from '../../../assets/images/evse_charger.svg';
import { ArcButton } from '../../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../../common/components/SlidingAnimationPageBase';
import { trackDynatraceEvseOnboardingStarted } from '../../../utils/native/dynatrace-events';
import { selectSite, setCurrentSite } from '../../site/siteSlice';
import { selectEvChargerData, setHasVisitedRegisterScreen } from '../dashboard/evChargerSlice';

/* istanbul ignore next -- @preserve */
export const DeviceRegister = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useReduxDispatch();
  const site = useSelector(selectSite);
  const { hasVisitedRegisterScreen } = useSelector(selectEvChargerData);
  const { t } = useTranslation();

  useEffect(() => {
    // Updating flag so that user is not redirected to this screen from dashboard again.
    if (!hasVisitedRegisterScreen) dispatch(setHasVisitedRegisterScreen(true));
  });

  const backURL = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('backURL') ?? `/sites/list`;
  }, [location.search]);

  return (
    <SlidingAnimationPageBase
      title={t('Common.device setup')}
      backURL={backURL}
      includeTopNavHamButton
      customNavigationDirection="forward"
      display="flex"
      flexDirection="column"
    >
      <Center flexDirection="column" px={3} textAlign="center" flex={1}>
        <Image data-testid="ev-charger-image" src={chargerImg} alt="EV Charger" my={4} />

        <Heading mt={2} size={'lg'}>
          {t('EVSE.pair with charger')}
        </Heading>
        <Text data-testid="ev-setup-text" mt={1}>
          {t('EVSE.pair with charger text')}
        </Text>

        <ArcButton
          data-testid="ev-charger-continue"
          onClick={() => {
            trackDynatraceEvseOnboardingStarted();
            dispatch(setCurrentSite({ ...site, isOnboarding: true }));
            return navigate(`../device-unplug-ev`);
          }}
          mt="auto"
          mb={8}
          w={'100%'}
          arcColor="#3DCD57"
        >
          {t('Common.continue')}
        </ArcButton>
      </Center>
    </SlidingAnimationPageBase>
  );
};
